var module = angular.module('octopusApp.projects');

module.controller('ChannelAddStepController', function ($scope, busy, $uibModalInstance, steps) {

   $scope.steps = steps;
   $scope.adding = { stepName: undefined };

   $scope.close = function() {
    $uibModalInstance.close();
   };

   $scope.save = function () {
    $uibModalInstance.close($scope.adding.stepName);
   };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/channels/add_step_controller.js
// module id = 506
// module chunks = 1